import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Mixpanel } from '../../config/Mixpanel'

const GetMyCertificateButton = ({ originalPrice, discountPrice, handleNavigate, event, text='For Just:' }) => {
    return (
        <div className='bg-shadow px-6 rounded-lg min-h-[48px] flex flex-col justify-center cursor-pointer btn--glow' onClick={() => {
            Mixpanel.track(event)
            handleNavigate()
        }}>
            <p className='font-medium text-black'>Get My Instant Certificate <FontAwesomeIcon icon={faArrowRight} className='arrow-move ml-1.5' /></p>
            <p className='text-xs text-black-text/80'><span className='text-xxs'>{text}</span> <span className='font-medium'>₹{discountPrice}</span> <span className='text-danger text-xxs line-through'>₹{originalPrice}</span> </p>
        </div>
    )
}

export default GetMyCertificateButton